import { CommissionsGroupByTable } from "../CommissionsGroupByTable";
import { CommissionsProcessingHold } from "../CommissionsProcessingHold";
import { CommissionsProcessingProcess } from "../CommissionsProcessingProcess";
import { CommissionsProcessingVoid } from "../CommissionsProcessingVoid";
import { DataSource, Layout, LayoutHeader, Panel, Splitter, Tab, Tabset } from "@mcleod/components";

export abstract class AutogenLayoutCommissionsProcessing extends Layout {
    layoutCommissionsProcessingHold: CommissionsProcessingHold;
    layoutCommissionsProcessingProcess: CommissionsProcessingProcess;
    layoutCommissionsProcessingVoid: CommissionsProcessingVoid;
    layoutGroupBy: CommissionsGroupByTable;
    layoutheaderCommissionsProcessing: LayoutHeader;
    panelContent: Panel;
    sourceCommissionsProcessing: DataSource;
    splitterCommissionsProcessing: Splitter;
    tabHold: Tab;
    tabProcess: Tab;
    tabVoid: Tab;
    tabsetCommissionsProcessing: Tabset;
}
